import script from "./MenuMobileButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuMobileButton.vue?vue&type=script&lang=ts&setup=true"

import "./MenuMobileButton.vue?vue&type=style&index=0&id=35c77d5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c77d5b"]])

export default __exports__